import TopBar from '@/components/feature/TopBar';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import WhatsAppButton from '@/components/feature/WhatsAppButton';
import { trustItems, siteConfig } from '@/mocks/data';

export default function AboutPage() {
  const whatsappHref = `https://wa.me/${siteConfig.whatsappNumber}?text=${encodeURIComponent('Merhaba, Atak Sistem Enerji hakkında bilgi almak istiyorum.')}`;

  return (
    <div className="min-h-screen bg-background-50">
      <TopBar />
      <Navbar />
      <main>
        <section className="py-16 md:py-20 bg-secondary-800">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6 text-center">
            <h1 className="font-heading text-2xl md:text-5xl text-background-50 mb-4">Hakkımızda</h1>
          </div>
        </section>

        <section className="py-16 md:py-20 bg-background-50">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto">
              <div className="space-y-5 text-foreground-600 text-sm md:text-base leading-relaxed mb-12">
                <p>
                  <strong className="text-foreground-900">Atak Sistem Enerji</strong>, Balıkesir ve bölge illerde ısı pompası, kat kaloriferi ve güneş enerjisi sistemleri alanında hizmet veren bir enerji ve ısıtma sistemleri firmasıdır.
                </p>
                <p>
                  Fineco Isı Pompaları Yetkili Bayisi olarak; kullanıcıların yaşam alanlarına uygun, modern, verimli ve uzun vadeli çözümler sunmayı hedefler.
                </p>
                <p>
                  Firma yaklaşımı; doğru ürün seçimi, güvenilir yönlendirme, kaliteli hizmet ve müşteri memnuniyeti üzerine kuruludur.
                </p>
              </div>

              <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-5">
                {trustItems.map((item) => (
                  <div key={item.id} className="flex items-center gap-3 bg-background-100 rounded-lg p-4 border border-background-200/70">
                    <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center shrink-0">
                      <i className={`${item.icon} text-accent-600 w-5 h-5 flex items-center justify-center`}></i>
                    </div>
                    <span className="text-sm text-foreground-700 font-medium">{item.text}</span>
                  </div>
                ))}
              </div>

              <div className="flex justify-center mt-10">
                <a href={whatsappHref} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-[#25D366] text-white px-6 py-3 rounded-md text-sm font-semibold hover:bg-[#1faa51] transition-colors whitespace-nowrap">
                  <i className="ri-whatsapp-line w-5 h-5 flex items-center justify-center"></i>
                  WhatsApp'tan Bilgi Al
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}